import React from 'react';
import { useParams } from 'react-router-dom';
import { BaseShareDialog, ShareableContent } from './BaseShareDialog';
import type { ToolPublic } from '@/types/tool';

interface ShareDialogProps {
  tool: ToolPublic;
  isOpen: boolean;
  onClose: () => void;
  onTrackShare: (platform: string) => void;
}

export const ShareDialog: React.FC<ShareDialogProps> = ({ 
  tool, 
  isOpen, 
  onClose, 
  onTrackShare 
}) => {
  const { lang } = useParams<{ lang?: string }>();
  const prefix = `/${lang || 'en'}`;
  
  const shareableContent: ShareableContent = {
    id: tool.id,
    title: tool.name,
    description: tool.description || '',
    url: `${window.location.origin}${prefix}/tools/${tool.slug || tool.id}`,
    category: tool.category?.name || undefined,
    upvotes: tool.upvotes_count,
    type: 'tool'
  };

  return (
    <BaseShareDialog
      content={shareableContent}
      isOpen={isOpen}
      onClose={onClose}
      onTrackShare={onTrackShare}
      customShareText={`Check out this amazing tool: ${tool.name}`}
    />
  );
}; 